<script lang="ts">
export default { name: 'CommonText', inheritAttrs: false }
</script>

<script setup lang="ts">
defineProps(['modelValue', 'id', 'disabled', 'type', 'placeholder', 'tel', 'zip', 'number', 'maxlength'])
const emit = defineEmits(['update:modelValue'])

/** inputイベント発火時の処理 */
function onInput(e: Event) {
  emit('update:modelValue', (e.target as HTMLInputElement).value)
}
</script>

<template>
  <span v-bind="$attrs">
    <input
      :type="type ?? 'text'"
      :id="id"
      :value="modelValue"
      :disabled="disabled"
      :placeholder="placeholder"
      :maxlength="maxlength"
      v-bind="number || tel || zip ? { inputmode: 'numeric' } : undefined"
      class="appearance-none border border-gray-300 rounded-[4px] w-full sm:p-[12px] p-[10px]"
      :class="{ 'text-right': number }"
      @input="onInput"
    />
  </span>
</template>
